<!-- Full Screen Modal Backdrop -->
<div class="fixed inset-0 bg-black/50 z-50 flex items-start justify-center" (click)="onBackdropClick($event)">
  <!-- Modal Container - Full page style per Figma with scroll -->
  <div class="relative bg-white w-full max-w-[1320px] h-screen overflow-y-auto" 
       role="dialog" 
       aria-modal="true" 
       aria-labelledby="modal-title"
       (click)="$event.stopPropagation()">
    
    <!-- Close Button - Fixed position -->
    <button 
      class="fixed top-6 right-6 z-30 w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700"
      (click)="close()" 
      aria-label="Close comparison">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>

    <!-- Modal Content -->
    <div class="py-8">
      @if (product(); as currentProduct) {
        <!-- Page Title -->
        <h1 id="modal-title" class="text-3xl font-bold text-base-700 mb-8 text-center"
          [ngClass]="isMobile() ? 'text-xl' : 'text-3xl'">
          {{ productName() }} - Full Comparison
        </h1>

        <!-- Plan Display with Full Comparison Mode -->
        @for (key of [modalKey()]; track 'modal-' + key) {
          <plan-display
            [componentKey]="'modal-' + key"
            [plans]="currentProduct.plans"
            [availableRegions]="availableRegions()"
            [showPopularBadge]="true"
            [showYearlyPricing]="true"
            [allowRegionSelection]="false"
            [allowRangedValueSelection]="false"
            [featureGroups]="currentProduct.featureGroups"
            [ungroupedFeatures]="currentProduct.ungroupedFeatures"
            displayMode="comparison"
            featuresMode="full"
            (onPlanSelect)="onPlanSelected($event)"
            (onRegionChange)="onRegionChange.emit($event)"
            (onRangedValueChange)="onRangedValueChange.emit($event)">
          </plan-display>
        }

        <!-- Back Button at bottom -->
        <div class="text-center mt-12 pb-8">
          <button 
            class="inline-flex items-center gap-2 px-6 py-3 bg-white border border-gray-300 text-gray-700 font-semibold rounded-md hover:bg-gray-50 transition-colors"
            (click)="close()">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
            </svg>
            Back to Pricing
          </button>
        </div>
      } @else {
        <div class="text-center py-16">
          <div class="text-6xl mb-4">📊</div>
          <h3 class="text-xl font-semibold text-gray-900 mb-2">No Product Selected</h3>
          <p class="text-gray-600">Please select a product to compare features.</p>
        </div>
      }
    </div>
  </div>
</div>
